/* eslint-disable */
import React, { useState } from 'react';
import './index.less';
import './index.en.less';
import arrowGif from '../../../../../../assets/2025/arrow.gif';

export interface IBubbleCardItem {
  title: string;
  content: string;
}

export interface IExpandableBubbleCardsProps {
  mainTitle: string;
  description?: string;
  items: IBubbleCardItem[];
  onComplete?: () => void;
  id?: string;
}

const ExpandableBubbleCards: React.FunctionComponent<IExpandableBubbleCardsProps> = ({
  mainTitle,
  description,
  items,
  onComplete,
  id,
}) => {
  const [currentIndex, setCurrentIndex] = useState<number>(-1);
  const [completedIndexes, setCompletedIndexes] = useState<Set<number>>(new Set());

  const handleItemClick = (index: number) => {
    if (index !== currentIndex + 1 && !completedIndexes.has(index)) return;
    
    const newCompleted = new Set(completedIndexes);
    newCompleted.add(index);
    setCompletedIndexes(newCompleted);
    setCurrentIndex(index);
    
    if (newCompleted.size === items.length && onComplete) {
      onComplete();
    }
  };

  const allCompleted = completedIndexes.size === items.length;
  const arrowIndex =
    !allCompleted && currentIndex + 1 < items.length
      ? currentIndex + 1
      : -1;

  return (
    <div className="expandable-bubble-cards" id={id}>
      <h2 className="ebc-main-title">{mainTitle}</h2>
      {description && <p className="ebc-description">{description}</p>}
      <div className="ebc-cards-container">
        {items.map((item, index) => {
          const isActive = completedIndexes.has(index);
          const showArrow = index === arrowIndex;
          const canClick = index === currentIndex + 1;
          return (
            <div
              key={index}
              className={`ebc-card-item ${isActive ? 'is-active' : 'is-inactive'} ${canClick ? 'can-click' : ''}`}
              onClick={() => handleItemClick(index)}
            >
              <div className="ebc-bubble-header">
                <span className="ebc-bubble-title">{item.title}</span>
                <div className="ebc-bubble-pointer" />
                {showArrow && (
                  <img src={arrowGif} alt="" className="ebc-guide-arrow" />
                )}
              </div>
              <div className="ebc-card-content">
                <p>{item.content}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExpandableBubbleCards;
